import { render } from "./AddressDetails.vue?vue&type=template&id=2a740e8b&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import "./AddressDetails.vue?vue&type=style&index=0&id=2a740e8b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a740e8b"]])

export default __exports__